import { getStyleFilterAnalytics } from '@/service/filter';
import { useStyleFilterStore } from '@/state/style-filter-list-store';
import { useRequest } from 'ahooks';
import { useMemo, useState } from 'react';
import { DateRange } from 'react-day-picker';

export const useFilterAnalyticsData = (isPublic: boolean, styleFilterId?: string, strength?: 'low' | 'high') => {
  const [date, setDate] = useState<DateRange | undefined>(undefined);
  const { analyticsData, setAnalyticsData } = useStyleFilterStore();

  const { loading } = useRequest(
    () => getStyleFilterAnalytics(date?.from?.toISOString().split('T')[0], date?.to?.toISOString().split('T')[0]),
    {
      ready: !!isPublic,
      // pollingInterval: 5000,
      refreshDeps: [date],
      onSuccess: (data) => {
        setAnalyticsData(data);
      },
    },
  );

  const processedStatsData = useMemo(() => {
    if (!analyticsData?.data) return [];

    if (styleFilterId && strength) {
      return [
        {
          label: 'Purchases',
          value: analyticsData.data.sf_list_detail?.[styleFilterId]?.detail?.[strength]?.total_purchases?.toLocaleString() ?? '0',
        },
        {
          label: 'Tracks Generated',
          value: analyticsData.data.sf_list_detail?.[styleFilterId]?.detail?.[strength]?.tracks_generated?.toLocaleString() ?? '0',
        },
        {
          label: 'Seconds Generated',
          value: analyticsData.data.sf_list_detail?.[styleFilterId]?.detail?.[strength]?.seconds_generated?.toLocaleString() ?? '0',
        },
        {
          label: 'Income Generated',
          value:
            '$' +
            (analyticsData.data.sf_list_detail?.[styleFilterId]?.detail?.[strength]?.revenue_generated?.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) ?? '0'),
        },
      ];
    }
    return [
      { label: 'Purchases', value: analyticsData.data.total_purchases?.toLocaleString() ?? '0' },
      { label: 'Tracks Generated', value: analyticsData.data.tracks_generated?.toLocaleString() ?? '0' },
      { label: 'Seconds Generated', value: analyticsData.data.seconds_generated?.toLocaleString() ?? '0' },
      // should be 2 decimal places with a $ sign.
      {
        label: 'Income Generated',
        value:
          '$' +
          (analyticsData.data.revenue_generated?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) ?? '0'),
      },
    ];
  }, [analyticsData, styleFilterId, strength]);

  return {
    processedStatsData,
    loading,
    date,
    setDate,
  };
};
